package com.neurobs.ccabserver.administrator.view

import com.neurobs.ccab.{CaasType, ResetCommunicationData, ResetCommunicationMessage}
import com.neurobs.js.ccab.{CCABChatSession, ControllerConnectionStatus}
import com.neurobs.js.view.{Gui, MessageBoxResult, ValueSelectBox}
import com.neurobs.js.dom.ElementFactory._
import com.neurobs.js.dom.SelectSelectBox
import org.scalajs.dom.raw.HTMLElement
import com.neurobs.js.dom.DOMViewElement._
import io.circe.generic.auto._
import com.neurobs.ccab.MessageData._

import scala.collection.mutable.{ArrayBuffer, ListBuffer}

object CommunicationResetView {
	private val boxWidth = 20
	private val formWidth = 40

	def show(gui: Gui, comm: CCABChatSession, allowReset: Boolean): Unit = {
		val canReset = allowReset && (comm.connectionStatus == ControllerConnectionStatus.Connected)

		val apiBox = SelectSelectBox(makeSelectBox(width = boxWidth))
		val api = ValueSelectBox(box = apiBox, items = List(CaasType.Opentok, CaasType.Agora), (t: CaasType.Value) => t.toString, (t: CaasType.Value) => t, noneEntry = true)

		val elements = ArrayBuffer[(HTMLElement, HTMLElement)](
			("Current API:", comm.apiType.toString),
			("Status:", comm.connectionStatus.toString)
		)
		val buttons = ListBuffer(("Ok", MessageBoxResult.Ok))
		if (canReset) {
			elements.append(("Reset API Override:", apiBox.select))
			buttons.append(("Reset Communications", MessageBoxResult.Yes))
		}
		val form = makeFormTable(elements.toArray)

		val description =
			"""Resetting communications causes Test Station to destroy its communication subsystem and restart it. This may be done at any time and should not disturb ongoing tests. A connection to Test Station is required. Resetting using the same Chat API should cause reconnection to this panel. When switching APIs, you must refresh the test station list and reconnect in a new panel."""

		gui.showModalCustomMessage(width = formWidth, title = "Test Station Communications", description = description, buttonCaptions = buttons, customContent = Some(form)) {
			case MessageBoxResult.Yes =>
				comm.send(ResetCommunicationMessage(data = ResetCommunicationData(api.value)))
			case _ =>
		}
	}
}
